module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TLxNmW/tc-custom/9781504073653.jpg?1705320834837",
      "alt": "This image is the cover for the book Devil's Play"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Devil's Play\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A secret society’s dark truths come to light when murder disrupts their circle in this riveting psychological mystery by the author of "), _c('i', [_vm._v("The Convent")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("Four troubled students have come together as an unlikely group of friends after joining an underground society at university—based around the celebration and practices of New Satanism. It is run by a charismatic and beautiful sociopath named Dillon, who exerts a strange power over Eleanor, Hunter, Natalie, and Seth."), _c('br'), _c('br'), _vm._v("Now their unhealthy bond has set in motion a chain of events that no one could have seen coming. When one of the friends dies unexpectedly, the police initially believe it’s accidental. But the victim’s father is convinced otherwise, and a spotlight is turned on the secret society and its members. The question is not only who is responsible for the murder, but exactly what sort of darkness lies behind it . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah Sheridan\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0